/**
 * @deprecated Use `MeterBarChart.Legend` instead.
 */
export const ThresholdLegend = () => null;

// eslint-disable-next-line @typescript-eslint/no-deprecated
ThresholdLegend['displayName'] = 'MeterBarChart.ThresholdLegend';
